import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { handleResponsiveCssValues, pxToRems, pxToRemsResponsive, } from '@awaze/design-system.utils.react';
import { useMemo } from 'react';
import styled from 'styled-components';
import { Heading } from './heading';
import { Text } from './text';
export const Headline = ({ children, description, hasBorder = false, maxWidth, sizes, marginBottom, darkTheme = false, ...rest }) => {
    const customSpacing = useMemo(() => {
        if (!hasBorder) {
            return !description ? 0 : 16;
        }
        const size = Array.isArray(sizes) ? sizes[0] : sizes;
        switch (size) {
            case 100:
                return 12;
            case 200:
            case 300:
                return 16;
            case 400:
                return 20;
            case 500:
                return 20;
            case 600:
                return 32;
            default:
                return 20;
        }
    }, [sizes]);
    return (_jsxs(Container, { mb: marginBottom, maxWidth: maxWidth, children: [_jsx(Heading, { sizes: sizes, mb: customSpacing, color: darkTheme ? 'ColorTextHeadingOnDark' : 'ColorTextHeadingOnLight', ...rest, children: children }), hasBorder && (_jsx(Border, { darkTheme: darkTheme, mb: !!description && customSpacing })), !!description && (_jsx(Text, { sizes: 300, color: darkTheme ? 'ColorTextBodyOnDark' : 'ColorTextBodyOnWhite', children: description }))] }));
};
const Container = styled.div `
  ${(p) => p.mb &&
    handleResponsiveCssValues({
        cssProperty: 'margin-bottom',
        value: pxToRemsResponsive(p.mb),
    })}
  ${({ maxWidth }) => maxWidth && `max-width: ${pxToRems(maxWidth)}`};
`;
const Border = styled.div `
  height: ${pxToRems(2)};
  width: ${pxToRems(44)};
  margin-bottom: ${({ mb }) => mb && `${pxToRems(mb)}`};
  background-color: ${({ darkTheme, theme }) => darkTheme ? theme.ColorWhiteOpacity20 : theme.ColorBlackOpacity20};
`;
//# sourceMappingURL=headline.js.map